// Browser Web Speech API wrapper for speech-to-text (STT).
export function getRecognition(continuous = false) {
  const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SR) return null;
  const rec = new SR();
  rec.continuous = continuous;
  rec.interimResults = true;
  rec.lang = "en-US";
  return rec;
}

export function speechSupported() {
  return !!(window.SpeechRecognition || window.webkitSpeechRecognition);
}

// Strip a leading wake phrase ("Hey Anna", "Hey Sam", "Anna", "Sam,") and return
// {text, wake:'anna'|'sam'|null}. Used for hands-free wake-word conversation.
export function parseWake(transcript) {
  const t = (transcript || "").trim();
  const m = t.match(/^\s*(hey|hi|ok|okay)?\s*(anna|sam)\b[\s,]*/i);
  if (m) {
    return { text: t.slice(m[0].length).trim(), wake: m[2].toLowerCase() };
  }
  return { text: t, wake: null };
}
